<template>
  <div class="public-attach-com">
    <div class="left">
      <uploadBase
        ref="uploadRef"
        :btnName="'上传新附件'"
        :uploadMethod="'uploadAttach'"
        :acceptList="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/pdf, .zip'"
        :extaParam="{
          isPicture: 0
        }"
        :fileSize="100"
        overSizeTip="，可以将文件上传到百度网盘，使用百度网盘链接"
        @cancelUpload="handelCancel"
        @uploadSuccess="handleSuccess"
        @beforeUpload="checkUpload"></uploadBase>
    </div>
    <div v-if="attcahList.length" class="middle">或者选择<br>已有素材</div>
    <div v-if="attcahList.length" class="right" v-loading='listLoading'>
      <div class="img-wrap" v-for="(item, index) in attcahList" :key="index" @click="selectAttach(item)">
        <img src="https://image.qsyhbgj.com/img-attach.png" alt="">
        <span class="name">{{item.name}}</span>
        <i class="el-icon-close" @click.stop="deleteAttach(item.id, index)"></i>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../api/index.js'
import uploadBase from '@/components/uploadBase'
export default {
  provide: {
    sceneName: 'attachUpload'
  },
  data () {
    return {
      listLoading: false,
      attcahList: []
    }
  },
  mounted () {
    this.getList()
  },
  activated () {
    this.getList()
  },
  methods: {
    handleSuccess (url) {
      this.attachUploading = false
      this.$emit('dispachUrl', url)
      this.getList()
    },
    getList () {
      api.getAttachList({
        isPicture: 0,
        pages: 50,
        pageNo: 1
      }).then(res => {
        if (res.code === 200) {
          this.attcahList = res.data.list
        }
      })
    },
    selectAttach (item) {
      this.$emit('dispachUrl', item)
    },
    deleteAttach (id, index) {
      this.listLoading = true
      api.deleteAttach({
        id: id
      }).then(res => {
        this.listLoading = false
        if (res.code === 200) {
          this.attcahList.splice(index, 1)
        }
      })
    },
    checkUpload () {
      if (this.attcahList.length >= 50) {
        this.$message({
          message: '每个用户最多拥有50条附件，请删除一条后再试',
          type: 'warning'
        })
        return
      }
      if (this.attachUploading) {
        this.$message({
          message: '请等待当前上传任务完成',
          type: 'warning'
        })
        return
      }
      this.attachUploading = true
      this.$emit('uploadBegain')
      this.$refs.uploadRef.doUpload()
    },
    handelCancel () {
      this.attachUploading = false
    }
  },
  components: {
    uploadBase
  }
}
</script>

<style lang="scss">
  .public-attach-com {
    display: flex;
    justify-content: center;
    align-items: center;
    .middle {
      flex: 0 0 auto;
      margin: 0 12px;
    }
    .right {
      flex: 1 1 140px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      height: 188px;
      overflow: auto;
      // display: flex;
      flex-wrap: wrap;
      padding: 12px;
      align-items: flex-start;
      .img-wrap {
        margin: 0 6px 2px 0;
        position: relative;
        border: 1px dashed transparent;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        &:hover {
          border-color: #409eff;
        }
        i {
          position: absolute;
          background: #fff;
          border: 1px solid #F56C6C;
          right: -8px;
          top: -8px;
          border-radius: 50%;
          color: #F56C6C;
          cursor: pointer;
        }
        img {
          height: 52px;
          width: 52px;
          flex: 0 0 52px;
        }
        .name {
          font-size: 12px;
        }
      }
    }
  }
</style>
